<template>
    <div v-if="tripadvisorRating.rating || tripadvisorRating.reviewsURL" class="tripadvisor">
        <template v-if="showLabel">
            <div v-if="!tripadvisorRating.reviewsURL" class="text-caption">
                {{ $t('tripadvisor_rating') }}
            </div>
            <div v-else class="text-caption">
                <a :href="tripadvisorRating.reviewsURL" target="_blank">{{ $t('tripadvisor_rating') }}</a>
            </div>
        </template>
        <img
            v-if="!tripadvisorRating.rating"
            :src="$filters.srcHost('/tripadvisor/ta.svg')"
            alt="Tripadvisor"
            height="20"
        />
        <img
            v-else
            :src="$filters.srcHost(`/tripadvisor/ta-${tripadvisorRating.rating * 10}.svg`)"
            :alt="tripadvisorRating.rating"
        />
        <div v-if="tripadvisorRating.reviewsCount" class="text-caption">
            {{ $t('based_on') }} <strong>{{ $t('review', tripadvisorRating.reviewsCount) }}</strong>
        </div>
    </div>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'

    //TODO Implement reviewsURL
    @Component
    export class HotelTripadvisorRatingLabel extends Vue {
        @Prop() tripadvisorRating

        get showLabel() {
            return false
        }
    }

    export default HotelTripadvisorRatingLabel
</script>
